import http from "./http";
const person = {
  getInfo() {
    return http.get("person/getInfo");
  },
  update(model) {
    return http.post("person/update", model);
  },

  sendSmsForBindMobile(mobile, captchaCode, captchaCodeKey) {
    return http.get(
      "person/sms/sendForBindMobile?mobile=" +
        mobile +
        "&captchaCode=" +
        captchaCode +
        "&captchaCodeKey=" +
        captchaCodeKey
    );
  },

  bindMobile(model) {
    return http.post("person/bindMobile", model);
  },

  sendSMSForResetPassword(mobile, captchaCode, captchaCodeKey) {
    return http.get(
      "person/sms/sendForResetPassword?mobile=" +
        mobile +
        "&captchaCode=" +
        captchaCode +
        "&captchaCodeKey=" +
        captchaCodeKey
    );
  },

  resetPassword(model) {
    return http.post("person/resetPassword", model);
  },
};
export default person;
